/**
反算工具类
ver 1.0.0
修改记录：
  2021-01-21：
    sheetsBackCountUtil.
*/
import calculateUtils from '../calculateUtil'
import objectUtil from '../objectUtil'

const getValue = objectUtil.getValueByPath

let ratioBackCountUtil = {}

/**
 * 参与计算对应字段 只做正向计算，即选择打印单位后计算，用户填写时不反向计算
 * @基本数量 {[amount]}
 * @基本单位 {[unit]}
 * @打印单位 {[unitDisplay]}
 * @每标签基本打印数量 {[amountBasic]} amountBasic = ratio.dividend/ratio.divisor
 * @建议打印张数 {[amountDisplay]} amountDisplay = 基本单位amount * ratio.divisor / ratio.dividend
 * @打印张数 {[sheet]} sheet = amountDisplay
 * @打印总张数 {[sheets]} sheets = sheet * copies 后台计算
 * @份数 {[copies]}  默认1 (暂时不展示)
 */

/**
 * [在表格中修改打印单位，修改 每标签基本打印数量，建议打印张数，打印张数]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 */

ratioBackCountUtil.unitDisplay = function (data, formData, decimal = 6) {
  if (!data.unitDisplay) {
    data['unitDisplay'] = {}
    if (!data.unitDisplay.ratio) {
      data.unitDisplay['ratio'] = {
        divisor: 1,
        dividend: 1,
      }
    }
  }
  if (!data.unitDisplay.ratio.divisor) data.unitDisplay.ratio.divisor = 1
  if (!data.unitDisplay.ratio.dividend) data.unitDisplay.ratio.dividend = 1

  data.amount = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.amountDisplay, data.unitDisplay.ratio.dividend, decimal),
    data.unitDisplay.ratio.divisor,
    decimal
  )
}

/**
 * [录入、修改基本数量]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 计量单位 : 计价单位 = divisor:dividend = 计量数量(amountDisplay) : 基本数量(amount)
 * 默认比例1:1
 */

ratioBackCountUtil.amountDisplay = function (data, formData, decimal = 6) {
  if (!data.unitDisplay) {
    data['unitDisplay'] = {}
    if (!data.unitDisplay.ratio) {
      data.unitDisplay['ratio'] = {
        divisor: 1,
        dividend: 1,
      }
    }
  }
  if (!data.unitDisplay.ratio.divisor) data.unitDisplay.ratio.divisor = 1
  if (!data.unitDisplay.ratio.dividend) data.unitDisplay.ratio.dividend = 1

  data.amount = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.amountDisplay, data.unitDisplay.ratio.dividend, decimal),
    data.unitDisplay.ratio.divisor,
    decimal
  )
}

/**
 * [整单折扣比例录入]
 * @param  {[type]} row    [折扣行数据 row]
 * @param  {[type]} data    [行数据 data]
 * @param  {[type]} formData    [单据数据]
 * @param  {[string]} ratioPath    [折扣比例取值路径]
 * @param  {[type]} decimal [保留小数多少位]
 *
 * 参考公式:
 *   主行和从行:
 *     无税金额 = 含税金额 / （1 + 税率）
 *     税额 = 含税金额 - 无税金额
 *   从行(折扣行):
 *     含税金额 = 含税金额(主行) * 折扣比例
 *     无税金额 = 无税金额(主行) * 折扣比例
 *     税额 = 税额 (主行) * 折扣比例
 */
ratioBackCountUtil.calcDiscountRatio = function (
  row,
  data,
  formData,
  decimal = 6,
  ratioPath = 'order.ratio'
) {
  // 折扣比例
  const ratio = calculateUtils.numberDiv(getValue(formData, ratioPath), 100, decimal)
  // 含税金额
  const priceTotal = -data?.priceTotal ?? 0
  // 无税金额
  const netMoney = -data?.netMoney ?? 0
  // 税额
  const netTax = -data?.netTax ?? 0

  // 折扣的含税金额
  row.priceTotal = calculateUtils.numberMul(priceTotal, ratio, decimal)
  // 折扣的无税金额
  row.netMoney = calculateUtils.numberMul(netMoney, ratio, decimal)
  // 折扣的税额
  row.netTax = calculateUtils.numberMul(netTax, ratio, decimal)
}

/**
 * [录入、修改无税金额]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 反算公式:
 *   无税金额 = 含税金额 / （1 + 税率）
 *   税额 = 含税金额 - 无税金额
 */

ratioBackCountUtil.netMoney = function (data, formData, decimal = 6) {
  // 无税金额
  const netMoney = data?.netMoney ?? 0
  // 税率
  const rate = data?.rate ?? 0

  // 含税金额
  data.priceTotal = calculateUtils.numberMul(
    netMoney,
    calculateUtils.numberAdd(1, rate, decimal),
    decimal
  )
  // 税额
  data.netTax = calculateUtils.numberSub(data.priceTotal, netMoney, decimal)
}

/**
 * [录入、修改税额]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 反算公式:
 *   无税金额 = 含税金额 / （1 + 税率）
 *   税额 = 含税金额 - 无税金额
 */

ratioBackCountUtil.netTax = function (data, formData, decimal = 6) {
  // 无税金额
  const netMoney = data?.netMoney ?? 0
  // 税额
  const netTax = data?.netTax ?? 0

  // 含税金额
  data.priceTotal = calculateUtils.numberAdd(netTax, netMoney, decimal)
}

export default ratioBackCountUtil
